module.exports = __webpack_public_path__ + "assets/img/nogrid-logo-small.89a93bba.webp";